import { graphqlApolloClient as client } from "../graphql-apollo-client"
import {
  GET_SUBMISSION_PROFILE_COMPLETENESS
} from "./graphql/queries/getImplementerProfileCompleteness"

/**
 * This service is used to check that the implementer profile of a given user
 * has filled the required fields.
 * @param userImplementerId
 * @return {Promise<*|null>}
 */
export const getImplementerProfileCompleteness = async ({ userImplementerId }) => {
  const { data } = await client.query({
    query: GET_SUBMISSION_PROFILE_COMPLETENESS,
    fetchPolicy: "network-only",
    variables: {
      userImplementerId
    }
  })

  return data?.ImplementerByUid || null
}
